<template>
  <!-- edit client -->
  <div id="btnShowTags" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Data Kontak {{ labelTitle }}</h5>
          <button id="btnCloseTags" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <template v-if="(dataSelectedGroup && broadcastParamSt.is_group_type=='tags')">
            <div class="row filter-row">
              <div class="col-sm-6 col-md-12">
                <div class="form-group form-focus">
                  <input @change="searchData" class="form-control floating" v-model="serverParams.keywords"
                    type="text" />
                  <label class="focus-label">Pencarian</label>
                </div>
              </div>
              <!-- <div class="col-sm-6 col-md-3">
                <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
              </div> -->
            </div>

            <div class="row">
              <!-- {{ broadcastParamSt }}
              {{ dataSelectedGroup }} -->
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table table-striped custom-table mb-0">
                    <thead>
                      <tr>
                        <th>Nama</th>
                        <th>No. WA</th>
                        <!-- <th>Email</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loading">
                        <tr>
                          <td colspan="2">
                            <Skeleton :count="1" />
                          </td>
                        </tr>
                      </template>
                      <template v-if="rows.length">
                        <tr v-for="(row, index) in rows" :key="index">
                          <td class="text-wrap">{{ row.first_name }}</td>
                          <td><a target="_blank"
                              :href="'https://api.whatsapp.com/send/?phone=' + row.phone_number + '&text&type=phone_number&app_absent=0'">{{
                                row.phone_number }}</a></td>
                          <!-- <td>{{ row.email }}</td> -->
                        </tr>
                      </template>
                      <template v-if="loading">
                        <tr>
                          <td colspan="2">
                            <Skeleton :count="1" />
                          </td>
                        </tr>
                      </template>
                      <template v-else-if="rows.length < 1 && !loading">
                        <tr>
                          <td colspan="2" class="text-center">-empty-</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row" v-if="totalRecords > serverParams.perPage">
              <div class="col-sm-12 col-md-6">
                <span class="footer__row-count__label">Displaying</span>
                <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                  v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                  <option value="10">10 / page</option>
                  <option value="20">20 / page</option>
                  <option value="30">30 / page</option>
                  <option value="40">40 / page</option>
                  <option value="50">50 / page</option>
                </select>
                <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
              </div>
              <div class="col-sm-12 col-md-6 text-right">
                <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                  :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                  <span class="chevron left"></span>
                  <span>Prev</span>
                </a>
                page
                <input style="width:100px;" min="1" type="number" v-model="currentPage"
                  @keyup.enter="onPageChange(parseInt(currentPage))" class />
                of {{ Math.ceil(totalRecords / serverParams.perPage) }}
                <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                  class="footer__navigation__page-btn" :class="'btn ' + {
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }">
                  <span>Next</span>
                  <span class="chevron right"></span>
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton,

  },
  data() {
    return {
      labelTitle: '',
      loading: false,
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      rows: [],
      dataSelectedGroup: false,
      serverParams: {
        keywords: '',
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
      }
    };
  },
  computed: {
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
  },
  methods: {
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    getGroupSelected(row) {
      this.dataSelectedGroup = row
      this.loadItems()
      // console.log("groupselected", row)
      // return convertUTCDatetimeToUnix(utcDatetime);
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      this.serverParams.group_id = []
      if (this.dataSelectedGroup.is_group == 1) {
        this.labelTitle = this.dataSelectedGroup.name
        this.serverParams.group_id.push({id:this.dataSelectedGroup.id})
        this.$store
          .dispatch("contact/getContactListFromTags", this.serverParams) // sesuai kan dengan method di API
          .then(response => {
            let data = response;
            this.totalRecords = data.totalRecords;
            this.rowPage = data.page;
            this.rows = data.data;
            // console.log("rows", this.rows);
            this.loading = false;
            // console.log("response", response)
          });
      }

    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: (this.serverParams.perPage * 1)
      });
      await this.loadItems();
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/previewTags.vue